import CurrencyFormatter from "currency-formatter"


export default class GoodwillReport {
  constructor({
    goodwillAmount,
    goodwillPercentageOfAssets,
    goodwillPercentageOfEquity,
    totalAssets,
    totalLiabilities
  }) {
    this.goodwillAmount = goodwillAmount
    this.goodwillPercentageOfAssets = goodwillPercentageOfAssets
    this.goodwillPercentageOfEquity = goodwillPercentageOfEquity
    this.totalAssets = totalAssets
    this.totalLiabilities = totalLiabilities
  }

  get equityValueOfBusiness() {
    return this.totalAssets - this.totalLiabilities
  }

  get formattedGoodwillAmount() {
    const result = CurrencyFormatter.format(this.goodwillAmount, { code: "USD", symbol: "$" })
    if(Array.from(result)[0] === "-") return "(" + result.replace(/-/g,"") + ")";
    else return result;
  }

  get formattedGoodwillPercentageOfAssets() {
    if(this.goodwillPercentageOfAssets < 0)
      return "(" + CurrencyFormatter.format(-this.goodwillPercentageOfAssets, { code: "USD", symbol: "" }) + " %)";
    return CurrencyFormatter.format(this.goodwillPercentageOfAssets, { code: "USD", symbol: "" })
  }

  get formattedGoodwillPercentageOfEquity() {
    if(this.goodwillPercentageOfEquity < 0)
      return "(" + CurrencyFormatter.format(-this.goodwillPercentageOfEquity, { code: "USD", symbol: "" }) + " %)";
    return CurrencyFormatter.format(this.goodwillPercentageOfEquity, { code: "USD", symbol: "" })
  }

  get formattedTotalAssets() {
    return CurrencyFormatter.format(this.totalAssets, { code: "USD", symbol: "$" })
  }

  get formattedTotalLiabilities() {
    return CurrencyFormatter.format(this.totalLiabilities, { code: "USD", symbol: "$" })
  }

  get formattedEquityValueOfBusiness() {
    return CurrencyFormatter?.format(this.equityValueOfBusiness, { code: "USD", symbol: "$" })
  }
}